<template>
  <el-dialog
    title="绿洲计划报名资料"
    :visible.sync="dialogVisible"
    width="900px"
    center
    @close="$refs['oasisParticipateInfoform'].resetFields();$emit('close',dialogVisible)">
    <div v-loading="loading">
      <!-- 绿洲行动资料 -->
      <div>
        <el-form ref="oasisParticipateInfoform" :model="form" :rules="formRules" label-width="100px" label-position="left">
          <div>
            <h3>证照信息</h3>
            <el-form-item label-width="0">
              <el-col :span="6.5">
                <el-form-item prop="checkstandForOasis">
                  <upload-img-ele v-model="form.checkstandForOasis" valueName="checkstandForOasis" label="收银台照(含微信相关物料)" @upload="uploadSuccess"></upload-img-ele>
                </el-form-item>
              </el-col>
              <el-col :span="6.5">
                <el-form-item prop="businessLicenseForOasis">
                  <upload-img-ele v-model="form.businessLicenseForOasis" valueName="businessLicenseForOasis" label="店内拍摄营业执照" @upload="uploadSuccess"></upload-img-ele>
                </el-form-item>
              </el-col>
              <el-col :span="6.5">
                <el-form-item prop="settledForOasis">
                  <upload-img-ele v-model="form.settledForOasis" valueName="settledForOasis" label="第三方平台入驻照" @upload="uploadSuccess"></upload-img-ele>
                </el-form-item>
              </el-col>
              <el-col :span="6.5">
                <el-form-item prop="bdMerchantHeadForOasis">
                  <upload-img-ele v-model="form.bdMerchantHeadForOasis" valueName="bdMerchantHeadForOasis" label="BD与商户门头照" @upload="uploadSuccess"></upload-img-ele>
                </el-form-item>
              </el-col>
            </el-form-item>
          </div>
          <div>
            <h3>公众号支付</h3>
            <el-form-item label="渠道商名称" prop="wxChannelId">
              <el-select
                class="dialog-form-item-margin-right"
                v-model="form.wxChannelId"
                :loading="selectLoading"
                clearable
                filterable>
                <el-option
                  v-for="item in oasisAgentChannelList"
                  :key="item.fChannelNo"
                  :label="item.fChannelName"
                  :value="item.fChannelNo"></el-option>
              </el-select>
              <div>备注：选择对应渠道商名称，在微信绑定商户和渠道商所属关系。若代理商无渠道号，请选择乐刷</div>
            </el-form-item>
          </div>
        </el-form>
        <div class="red-tip">备注:若商户信息中无营业执照请先补齐再申请参加绿洲计划，营业执照为绿洲计划必须资料</div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import UploadImgEle from '../../../components/upload/uploadImgEle'
import { getAgentChannel, updateDetailInfo } from '@/api/merchant'
export default {
  name: 'JoinOasis',
  components: {
    UploadImgEle
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        merchantId: '',
        checkstandForOasis: '',
        businessLicenseForOasis: '',
        settledForOasis: '',
        bdMerchantHeadForOasis: '',
        wxChannelId: '',
        payAppid: '',
        payConfigCatalog: '',
        followAppid: ''
      },
      formRules: {
        checkstandForOasis: [
          { required: true, message: '请上传收银台照' }
        ],
        businessLicenseForOasis: [
          { required: true, message: '请上传店内拍摄营业执照' }
        ],
        settledForOasis: [
          { required: true, message: '请上传第三方平台入驻图' }
        ],
        bdMerchantHeadForOasis: [
          { required: true, message: '请上传BD与商户门头照' }
        ],
        bdMerchantYylForOasis: [
          { required: true, message: '请上传BD与商户门店摇摇乐照片' }
        ],
        wxChannelId: [
          { required: true, message: '请选择微信渠道商', trigger: 'change' }
        ]
      },
      selectLoading: false, // 选择渠道商名称可选择列表
      oasisAgentChannelList: [],
      isSelfSetOasisInfoWxInfo: true
    }
  },
  mounted () {
    this.dialogVisible = this.visible
    this.form.merchantId = this.id
    this.getOasisAgentChannel()
  },
  methods: {
    /**
             * @description 图片上传成功的回调
             * @param {Object} data 回调数据对象
             */
    uploadSuccess (data) {
      const name = data.valueName
      this.form[name] = data.path
    },
    /**
             * @description 绿洲计划代理商查询微信渠道信息
             */
    getOasisAgentChannel () {
      return new Promise((resolve, reject) => {
        this.selectLoading = true
        getAgentChannel('').then(response => {
          this.selectLoading = false
          if (response.error_code === '0') {
            this.oasisAgentChannelList = response.data
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
             * @description 点击取消
             */
    cancel () {
      this.$confirm('请确认是否放弃当前修改内容', '提示', {
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false
      })
    },
    /**
             * @description 点击提交
             */
    submit () {
      this.$refs.oasisParticipateInfoform.validate(valid => {
        if (valid) {
          this.$confirm('请确认是否提交审核', '提示', {
            type: 'warning'
          }).then(async () => {
            await this.updateInfo()
            this.dialogVisible = false
            this.$emit('submit', true)
          })
        } else {
          console.log('error submit!!')
          this.$message({
            message: '提交信息有误，请完善后重新提交',
            type: 'error'
          })
          return false
        }
      })
    },
    /**
             * @description 提交参加绿洲计划资料
             */
    updateInfo () {
      return new Promise((resolve, reject) => {
        this.loading = true
        const params = qs.stringify(this.form)
        updateDetailInfo(params).then(response => {
          this.loading = false
          if (response.error_code === '0') {
            this.$message({
              message: '资料提交成功',
              type: 'success'
            })
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
    .red-tip{
        color: red;
    }
    .uploadImgDiv{
        width:200px
    }
</style>
